export default function CustomEventCreator<T = object>(
  type: string,
  {
    bubbles = false,
    cancelable = false,
    detail = null,
  }: { bubbles?: boolean; cancelable?: boolean; detail?: T | null }
) {
  return typeof window.CustomEvent === 'function'
    ? new window.CustomEvent(type, { bubbles, cancelable, detail })
    : (() => {
        const event = document.createEvent('CustomEvent');
        event.initCustomEvent(type, bubbles, cancelable, detail);
        return event as CustomEvent<typeof detail>;
      })();
}
